import React from 'react'

const OfferteContext = React.createContext()

export default OfferteContext
